module.exports = __webpack_public_path__ + "static/media/motorViolations.de739b7c.svg";